import { motion } from "framer-motion";
import { cn } from "@/lib/cn";

const SPRING = { type: "spring" as const, stiffness: 300, damping: 30 };

const SECTION_VARIANTS = {
  hidden: { opacity: 0, y: 12 },
  visible: { opacity: 1, y: 0, transition: SPRING },
};

const WARNING_STEPS = [
  { step: "1st", action: "Warning", color: "bg-amber-400" },
  { step: "2nd", action: "Mute 1h", color: "bg-orange-400" },
  { step: "3rd", action: "Mute 24h", color: "bg-orange-500" },
  { step: "4th", action: "Kick", color: "bg-red-400" },
  { step: "5th", action: "Ban", color: "bg-red-600" },
];

export function WarningLadderSection() {
  return (
    <motion.section variants={SECTION_VARIANTS} className="mb-5">
      <h2 className="mb-2 text-xs font-semibold uppercase tracking-wider text-[var(--color-text-muted)]">
        Warning Ladder
      </h2>
      <div className="rounded-[var(--radius-lg)] bg-[var(--color-surface)] p-4">
        <div className="flex flex-col">
          {WARNING_STEPS.map((step, index) => (
            <div key={step.step} className="flex items-start gap-3">
              <div className="flex flex-col items-center">
                <div
                  className={cn(
                    "flex h-8 w-8 shrink-0 items-center justify-center",
                    "rounded-full text-[11px] font-bold text-white",
                    step.color,
                  )}
                >
                  {step.step}
                </div>
                {index < WARNING_STEPS.length - 1 && (
                  <div className="h-6 w-0.5 bg-[var(--color-border)]" />
                )}
              </div>
              <div className="pt-1.5">
                <p className="text-sm font-medium text-[var(--color-text)]">
                  {step.action}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </motion.section>
  );
}
